import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { useT } from "../i18n";
import { picOr } from "../components/pics";

const ToastContext = createContext(null);
let nextId = 1;

export function ToastProvider({ children }) {
  const tr = useT();
  const [toasts, setToasts] = useState([]);

  const dismiss = useCallback((id) => setToasts((t) => t.filter((x) => x.id !== id)), []);

  const toast = useCallback(
    (t) => {
      const id = nextId++;
      const item = { id, emoji: "sparkle", duration: 4000, ...(typeof t === "string" ? { title: t } : t) };
      setToasts((list) => [...list.slice(-4), item]);
      if (item.duration) setTimeout(() => dismiss(id), item.duration);
      return id;
    },
    [dismiss]
  );

  const value = useMemo(() => ({ toast, dismiss }), [toast, dismiss]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="toast-stack" role="status" aria-live="polite">
        {toasts.map((t) => (
          <div key={t.id} className={`toast toast-${t.kind || "info"}`}>
            <span className="toast-emoji">{picOr(t.emoji)}</span>
            <div className="toast-body">
              <strong>{t.title}</strong>
              {t.body && <span>{t.body}</span>}
            </div>
            {t.action && (
              <button
                className="btn btn-sm btn-primary"
                onClick={() => {
                  t.action.onClick();
                  dismiss(t.id);
                }}
              >
                {t.action.label}
              </button>
            )}
            <button
              className="toast-close"
              aria-label={tr("Dismiss")}
              onClick={() => {
                t.onDismiss?.();
                dismiss(t.id);
              }}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);
